import { defineCustomElements } from 'cookie-banner/dist/loader';

export default class CookieBannerManager {
  public load(isNativePlatform: boolean) {
    if (!isNativePlatform) {
      defineCustomElements(window); /**  Bind the custom elements to the window object */
    }
  }
}
